export enum enumTransStatusAfterSuccessful {
  'Imported' = 1,
  'Processed',
  'Rejected',
  'Completed',
  'Manually Processed',
  'Cancelled',
  'In Tracking'
}

export namespace enumTransStatusAfterSuccessful {
  export function values() {
    return Object.keys(enumTransStatusAfterSuccessful).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
